import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import LanguageContext from '../../contexts/language-context';
import Notifications from '../notifications';
import useTimeout from '../../hooks/use-timeout';

const LOADING_SPINNER_DELAY = 500;

export default function VhtApplication(props) {
  const {navigation = [], initializers = []} = props;
  const [initialized, setInitialized] = React.useState(false);
  const [isLoadingSpinnerDisplayed, setIsLoadingSpinnerDisplayed] = React.useState(false);
  const {language, setLanguage: setLanguageState} = React.useContext(LanguageContext);
  const loadingSpinnerTimeout = useTimeout(showLoadingSpinner, LOADING_SPINNER_DELAY);

  React.useEffect(() => {
    initialize();
    loadingSpinnerTimeout.start();
  }, []);

  React.useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  async function initialize() {
    try {
      const appNamespaces = navigation.reduce((namespaces, app) => {
        namespaces.push(app.id);
        return namespaces;
      }, []);
      await i18n.init(undefined, appNamespaces);
      setLanguageState(i18n.getLanguage());

      for (const initializer of initializers) {
        await initializer();
      }
      setInitialized(true);
    } catch (ex) {
      console.error('ERROR', ex);
      setInitialized(false);
    }
  }

  function showLoadingSpinner() {
    setIsLoadingSpinnerDisplayed(true);
  }

  function renderLoading() {
    return (
      <div className="react-loading-container" style={isLoadingSpinnerDisplayed ? {} : {display: 'none'}}>
        <span className="react-loading fas fa-spinner" />
      </div>
    );
  }

  return <Notifications>{initialized ? props.children : renderLoading()}</Notifications>;
}

VhtApplication.propTypes = {
  children: PropTypes.node,
  /** As array of async functions (or that return a promise) to run to bootstrap the app.
   * Child components will not be rendered until all these functions complete. */
  initializers: PropTypes.array,
  /** Navigation structure for the application. */
  navigation: PropTypes.array,
};
